export interface LatestNewsProps {
  image: string
  title: string
  link: string
  date: string
  isWhite: boolean
}

export const useLatestNews = (props: LatestNewsProps) => {
  return {
    ...props,
  }
}
